import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from 'src/app/services/settings.service';

@Injectable({ providedIn: 'root' })
export class CustomNgbDateParserFormatter extends NgbDateParserFormatter {
  constructor(
    private datePipe: DatePipe,
    private settingsService: SettingsService
  ) {
    super();
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      let parsedDate = new Date(value);
      return {
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth() + 1,
        day: parsedDate.getDate(),
      };
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (date) {
      let dateFormat = this.settingsService.get().dateFormat;
      let parsedDate = new Date(date.year, date.month - 1, date.day);
      let transformedDate = this.datePipe.transform(parsedDate, dateFormat);
      return transformedDate;
    }

    return '';
  }
}
